<template>
  <LayoutPage
    :title="[pageTitle, smartUnitName, 'Assigned Devices']"
    :loading="smartUnitLoading"
  >
    <template #actions>
      <v-btn color="primary" class="action-btn" @click="showQRDialog = true">
        <v-icon left>fas fa-qrcode</v-icon>
        Scan Device
      </v-btn>
    </template>

    <v-row>
      <v-col lg="6">
        <CardAssignedDevices allow-actions />
      </v-col>

      <v-col lg="6">
        <CardDeviceInventory :zone-id="unitId" :smart-unit="smartUnit" />
      </v-col>
    </v-row>

    <QRCodeDialog
      v-model="showQRDialog"
      title="Assign Device"
      description="Scan this QR code with your mobile phone or tablet to assign a device to this unit."
      :url-generator="generateDeviceAssignUrl"
    />
  </LayoutPage>
</template>

<script>
import { computed, ref } from "vue";
import LayoutPage from "@layout/LayoutPage.vue";
import CardAssignedDevices from "./CardAssignedDevices.vue";
import CardDeviceInventory from "./CardDeviceInventory.vue";
import QRCodeDialog from "../mobile/QRCodeDialog.vue";
import useSmartUnit from "./useSmartUnit";

export default {
  name: "PageSmartUnitDevices",

  components: {
    LayoutPage,
    CardAssignedDevices,
    CardDeviceInventory,
    QRCodeDialog,
  },
  setup() {
    const { smartUnit, smartUnitLoading, fetchSmartUnit } = useSmartUnit();
    const smartUnitName = computed(() => smartUnit.value?.name || "...");
    const showQRDialog = ref(false);
    return {
      smartUnit,
      smartUnitName,
      smartUnitLoading,
      fetchSmartUnit,
      showQRDialog,
    };
  },
  computed: {
    unitId() {
      return this.$route.params.zone_id;
    },
    subtype() {
      return this.$route.query.subtype;
    },
    pageTitle() {
      return this.subtype === "zone" ? "Smart Zones" : "Smart Units";
    },
  },
  watch: {
    //in case of push route to the same page component doesn't remount
    async unitId(newId) {
      await this.fetchSmartUnit(this.$apollo, newId);
    },
  },
  async beforeMount() {
    await this.fetchSmartUnit(this.$apollo, this.unitId);
  },
  methods: {
    generateDeviceAssignUrl(qrToken) {
      const baseUrl = window.location.origin;
      const facilityId = this.$route.params.organization_id;
      return `${baseUrl}/mobile-inventory?qrToken=${encodeURIComponent(
        qrToken
      )}&facility=${facilityId}&zoneId=${this.unitId}`;
    },
  },
};
</script>
